import { SEED_INVOICES } from './seed-invoices';
import type { AgingInvoice } from './seed-invoices';

/** Customers with at least one open (non-disputed) invoice — eligible for
 *  procedural payment arrivals. */
export const PAYMENT_ELIGIBLE_CUSTOMERS: readonly string[] = (() => {
  const set = new Set<string>();
  for (const inv of SEED_INVOICES) {
    if (inv.status !== 'disputed') set.add(inv.customer);
  }
  // Exclude scripted-only customers — Peak (beat-3) and TechStart (beat-4
  // doesn't have invoices in the seed) — to keep beats distinct from
  // procedural noise.
  set.delete('Peak Industries');
  return [...set];
})();

export const openInvoicesForCustomer = (customer: string): readonly AgingInvoice[] =>
  SEED_INVOICES.filter((inv) => inv.customer === customer && inv.status !== 'disputed');

const REMITTANCE_TEMPLATES_CLEAR: readonly ((c: string, m: string) => string)[] = [
  (c) => `${c} — invoice payment`,
  (c) => `${c} A/P — wire`,
  (c, m) => `${c} ref ${m}`,
];

const REMITTANCE_TEMPLATES_MURKY: readonly string[] = [
  'Wire ref 89234-A — please apply',
  'AP wire — see attached PDF',
  'Customer reference unclear',
  'Payment received — no remittance',
];

const fmtRef = (rng: () => number): string => {
  const n = Math.floor(10_000 + rng() * 89_999);
  return `${n}`;
};

/** Build a remittance hint string. 70% mention the customer; 30% are murky. */
export const buildRemittanceHint = (customer: string, rng: () => number): string => {
  if (rng() < 0.7) {
    const tpl = REMITTANCE_TEMPLATES_CLEAR[
      Math.floor(rng() * REMITTANCE_TEMPLATES_CLEAR.length)
    ];
    return tpl(customer, fmtRef(rng));
  }
  return REMITTANCE_TEMPLATES_MURKY[Math.floor(rng() * REMITTANCE_TEMPLATES_MURKY.length)];
};
